<template>
  <div class="McfBgImgPc" :style="{background: `url(${backgroundPic})no-repeat center`}">
    <div class="w-100 bg-white500 shadow-custom">
      <div class="container py-1 d-flex justify-content-between align-items-center">
        <div v-if="imageLoadingCompleted" class="logo">
          <!-- logo begin -->
          <img :src="brandLogoPic" alt="" style="cursor: pointer" @click="redirectBrandHomePage">
        </div>
        <!-- logo end -->
        <div style="cursor: pointer" @click="!hasLogged && login()">
          <a href="javascript:void(0)" class="image-panel image-panel-0 rounded-circle mx-1" :class="btnClass" :id="hasLogged ? 'MemberHead' : ''">
            <span class="material-icons" :class="iconClass">perm_identity</span>
          </a>
          <a v-if="!hasLogged" class="font-size-md text-customize">{{ $t('global.login') }}</a>
          <b-popover v-else target="MemberHead" triggers="focus" placement="bottomcenter" custom-class="header-setting-popover">
            <div class="font-size-md">
              <b-list-group class="py-2">
                <b-list-group-item v-if="!$route.path.includes('membercenter')" href="javascript:void(0)" class="border-0 py-2" @click="redirectMembercenterIndex()">{{ membercenterWording }}</b-list-group-item>
                <b-list-group-item href="javascript:void(0)" class="border-0 py-2" @click="logout()">{{ $t('global.logout') }}</b-list-group-item>
              </b-list-group>
            </div>
          </b-popover>
        </div>
      </div>
    </div>
    <Popup :isOpen.sync="popup.isOpen" :content="popup.content" :mode="popup.mode" @confirm="popup.confirmPopup" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Popup from '@/components/Popup.vue';
import commonTool from '../utils/commonTool';
import pageSettingGetter from '../utils/pageSettingGetter';

const redeemRoutes = commonTool.getIgnoreRoutes();

export default {
  components: {
    Popup,
  },
  data() {
    return {
      // 資料是否完成載入
      imageLoadingCompleted: false,
      // 背景圖
      backgroundPic: '',
      // 品牌 Logo 圖
      brandLogoPic: '',
      // 品牌 Logo 圖點擊後連結網址
      brandLogoLinkUrl: '',
      popup: {
        // 是否開啟
        isOpen: false,
        // 內容
        content: '',
        // 顯示
        mode: 'default',
        confirmPopup: () => {},
      },
      // 會員中心文案
      membercenterWording: '',
    };
  },
  computed: {
    ...mapGetters('memberSource', ['isAnswerChanged']),
    // 是否登入
    hasLogged() {
      return !!this.$store.state.accessToken;
    },
    // 圖示 class
    btnClass() {
      return {
        'border-customize bg-white border': !this.hasLogged,
        'bg-customize': this.hasLogged,
      };
    },
    // 圖示 class
    iconClass() {
      return {
        'text-customize': !this.hasLogged,
        'text-white': this.hasLogged,
      };
    },
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        vm.membercenterWording = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        vm.backgroundPic = setting.backGroundPic;
        vm.brandLogoPic = setting.brandLogoPic;

        let promise = Promise.resolve();
        // 有開啟網訊商城連結 => 前往商城；否則為原功能
        if (setting.isTEECLink) {
          promise = commonTool.getPersonalStoreUrl().toPromise().then((url) => {
            vm.brandLogoLinkUrl = url;
          });
        } else { vm.brandLogoLinkUrl = setting.brandLogoLinkUrl; }

        return promise;
      })
      .then(() => { vm.imageLoadingCompleted = true; });
  },
  methods: {
    // 登入
    login() {
      const query = redeemRoutes.includes(this.$route.name) ? { verify: 'true' } : {};
      commonTool.login(window.location.pathname, query);
    },
    // 登出
    logout() {
      const vm = this;

      // 執行登出的動作
      const excuteLogout = () => {
        // 清除 cookie
        commonTool.deleteCookie(`accessToken_${vm.$store.state.companyId}_${vm.$store.state.memberSourceId}`);
        // 設定 state 內 accessToken
        vm.$store.commit('set', { name: 'accessToken', value: '' });
        // 設定 memberId
        vm.$store.commit('set', { name: 'memberId', value: '' });
        // 兌禮頁面以外登出後，跳轉至登入頁
        if (!redeemRoutes.includes(vm.$route.name)) commonTool.login(window.location.pathname);
      };

      // 若位於會員資料修改頁，需檢查是否為未保存離開
      if (vm.$route.name === 'personalInfo' && vm.isAnswerChanged) {
        vm.popup = {
          isOpen: true,
          title: vm.$t('global.leave-without-save'),
          content: vm.$t('global.leave-without-save-warn'),
          mode: 'default',
          confirmPopup: () => {
            // 取消「離開頁面」事件
            window.onbeforeunload = null;
            excuteLogout();
          },
        };
        return;
      }
      excuteLogout();
    },
    // 導向品牌首頁
    redirectBrandHomePage() {
      window.location.href = this.brandLogoLinkUrl;
    },
    // 導向會員中心首頁
    redirectMembercenterIndex() {
      const vm = this;
      vm.$router.push({ name: 'index', query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
    },
  },
};
</script>

<style>
.McfBgImgPc{ width: 100%; min-height: 240px; background-repeat: no-repeat;}
.McfBgImgPc .logo img{ height: 40px; width: auto;}
</style>
